// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4aBfP","body":"styles_body__EEsbZ","aboutText":"styles_aboutText__DrC6W"};